import React from 'react';
import HoldingsChart from "./ConsolidatedChart.react";

const ConsolidatedCharts = ({asset, graphData}) => {
  return (
    <>
      <div className={'exchange-breakdown-container'}>
        <div className={'exchange-holdings'}>
          <div className={'holdings-title'}>
            <div className={'square-blue'}/>
            Exchange Holdings
          </div>
          {asset && <div>1,343 {asset.code}</div>}
          <div>$2,461,722.11 USD</div>
        </div>

        <div className={'user-holdings'}>
          <div className={'holdings-title'}>
            User Holdings
            <div className={'square-green'}/>
          </div>
          {asset && <div>5375 {asset.code}</div>}
          <div>$2,461,722.11 USD</div>
        </div>
      </div>
      <div className={'graph-section'}>
        <HoldingsChart data={graphData} />
      </div>
    </>
  )
}

export default ConsolidatedCharts;